import React from 'react'
import {api} from 'lib/url'
import DownloadFile from 'organization/DownloadFile'
import {useParams} from 'react-router-dom'

export default function DownloadAllFormSubmissions() {
  const {file} = useParams<{file: string}>()
  const url = api(`/all_form_submissions/${file}`)
  return <DownloadFile url={url} />
}
